export interface TaskActionIconDTO {
	type: TaskActionIconType;
	value: string | null;
}

export enum TaskActionIconType {
	STATIC = 'static',
	FILE = 'file',
}

export default class TaskActionIcon {
	private _type: TaskActionIconType;
	private _value: string | null;

	constructor(taskActionIconDTO: TaskActionIconDTO) {
		this._type = taskActionIconDTO.type;
		this._value = taskActionIconDTO.value;
	}

	get type() {
		return this._type;
	}

	get value() {
		return this._value;
	}
}
